import React from 'react';
import PropTypes from 'prop-types';
import Portal from './../common/Portal';
import Row from './layout/Row';
import Button from './Button';
import { Visibility } from '../util/Constants';
import { ThemeSetup } from '../themes/ThemeSetup';

import './ActionSheet.css';

const { VISIBLE, HIDING, HIDDEN } = Visibility;

class ActionSheet extends React.Component {
  static propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    children: PropTypes.any
  };

  state = {
    viz: Visibility.HIDDEN
  };

  componentDidMount() {
    this.setViz(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.show !== nextProps.show) {
      this.setViz(nextProps);
    }
  }

  setViz = (props) => {
    const { show } = props;
    const { viz } = this.state;

    if (viz === HIDDEN && show) {
      this.setState({ viz: VISIBLE });
    } else if (viz === VISIBLE && !show) {
      this.setState({ viz: HIDING });
      setTimeout(() => {
        if (this._node) {
          this.setState({ viz: HIDDEN });
        }
      }, 250);
    }
  };

  render() {
    const { close, children } = this.props;

    const { viz } = this.state;

    return (
      <Portal defaultOpen={true}>
        <div className={(viz || '').toLowerCase()} name="ActionSheet" ref={(node) => (this._node = node)}>
          <Row align="RIGHT" className="header">
            <Button icon={ThemeSetup.getImageURL('cross.svg')} onClick={close} />
          </Row>
          <div className="body">{children}</div>
        </div>
      </Portal>
    );
  }
}

export default ActionSheet;
